// @flow
export const PUSH_BREADCRUMB = 'PUSH_BREADCRUMB';
export const PUSH_MULTIPLE_BREADCRUMBS = 'PUSH_MULTIPLE_BREADCRUMBS';
export const POP_BREADCRUMB = 'POP_BREADCRUMB';

export const MOUNT_POINT = 'breadcrumbs';
